<template>
  <div id="page-product-details">
    <FDO-form
        v-model="model"
        ref="form"
        :facility-id="$route.params.id"
        :loading="loading"
        :card-title="`FDO: ${ model.FDODescription }`"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              class="my-4"
              @click="$router.push({ name: 'facilities.fdos.list' })"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              class="my-4"
              color="light"
              @click="save"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          
          
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import NotificationMixin from "@/components/mixins/NotificationMixin";
import FDOForm from '@/views/pages/facilities/fdos/FDOForm';
import ViewModelMixin from '@/components/mixins/ViewModelMixin';
import SaveModelMixin from '@/components/mixins/SaveModelMixin';

export default {
  name: "FDOEdit",
  components: {
    FDOForm,
  },
  mixins: [ViewModelMixin, SaveModelMixin, NotificationMixin],
  data() {
    return {
      loading: false,
      modelEntity: this.$api.facilities.fdos,
      entity: 'FDO',
      confirmedUnderwriters: false,
      existingUnderwriters: [],
    };
  },
  computed: {
    id() {
      return this.$route.params.fdoId;
    }
  },
  methods: {
    getParams() {
      const params = this.getModelCopy(true);

      const dates = [
        'InceptionDate',
        'ExpiryDate'
      ];

      const references = [
        'Market_FK'
      ];

      const multiReferences = [{
        array: 'sections',
        key: ['Section_FK'],
      }];

      this.setDates(dates);
      this.setReferences(references);
      this.setMultiReferences(multiReferences);

      params.underwriters.forEach((underwriter) => {
        this.setReferences(['CompanyInsurer_FK', 'InsurerRole_FK'], underwriter);
        // Not needed
        underwriter.sections.forEach((section) => delete section.Section);
      });

      params.Facility_FK = this.id;

      return params;
    },
    async fetch(id) {
      try {
        this.loading = true;
        const {data} = await this.modelEntity.get(id);

        const fdo = data.data;
        fdo.underwriters = fdo.insurer_securities.map((underwriter) => {
          // Map the sections to our own format
          underwriter.sections = underwriter.sections.map((section) => ({
            InsurerSectionReference: section.reference.InsurerSectionReference,
            Section_FK: Number(section.reference.Section_FK),
            Section: section.Section,
          }))

          return underwriter;
        });

        // We don't need this as we overwrite it with underwriters
        delete fdo.insurer_securities;

        this.model = fdo;

        this.existingUnderwriters = fdo.underwriters.map(({FDO_PK}) => FDO_PK);
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false;
        if (!this.model) {
          this.not_found = true
        }
      }
    },
    validateParams({underwriters, sections}) {
      if (sections.length === 0) {
        this.notifyError('At least one section is required.');
        return false;
      }

      if (underwriters.length === 0) {
        this.notifyError('At least one underwriter is required.');
        return false;
      }

      const hasRemovedAnExistingUnderwriter = (newUnderwriters) => {
        const newUnderwritersIds = newUnderwriters
            .filter(({FDO_PK}) => FDO_PK !== null)
            .map(({FDO_PK}) => FDO_PK);

        let changed = false;
        this.existingUnderwriters.forEach((id) => {
          if (!newUnderwritersIds.includes(id)) {
            changed = true;
          }
        });

        return changed;
      };

      if (!this.confirmedUnderwriters && hasRemovedAnExistingUnderwriter(underwriters)) {
        const message = 'One or more existing underwriters have been removed. This will remove their section references and distribution lists. Do you want to proceed?';
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Confirm Save',
          text: message,
          accept: async () => {
            this.confirmedUnderwriters = true;
            await this.save();
            this.confirmedUnderwriters = false;
          },
          acceptText: 'Save'
        })
        return;
      }

      return true;
    },
    postSave() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>

</style>
